<template>
  <div
    :style="paddingCalculator"
    v-if="_.size(_.get(contentData, 'data.list[0].additional_images'))"
  >
    <div class="event-gallery container">
      <div class="title tbc-bold font-16 uppercase">
        {{ $fn.tr("Gallery") }}
      </div>
      <swiper
        ref="gallery"
        class="gallerySwiper gallery-list grab"
        :options="swiperOptions"
      >
        <swiper-slide
          v-for="(image, index) in _.get(
            contentData,
            'data.list[0].additional_images'
          )"
          :key="image.id"
        >
          <div class="image-cont" @click="activeSwiper(index)">
            <div class="img-filter br-12 overlay-img"></div>
            <picture>
              <source
                media="(max-width: 767px)"
                :srcset="_.get(image, 'devices.mobile')"
              />
              <source
                media="(max-width: 1023px)"
                :srcset="_.get(image, 'devices.tablet')"
              />
              <img :src="_.get(image, 'devices.desktop')" alt />
              <div class="hover-symbol">
                <light-gallery-symbol />
              </div>
            </picture>
          </div>
        </swiper-slide>
        <div class="swiper-scrollbar" slot="scrollbar">
          <div
            class="swiper-scrollbar-drag"
            style="width: 30%"
            slot="scrollbar"
          ></div>
        </div>
      </swiper>
      <div class="nav-btns flex-box desk">
        <div class="catalogue-btn-prev" slot="button-prev">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <path
              id="Combined_Shape_Copy_2"
              data-name="Combined Shape Copy 2"
              d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
              transform="translate(0 0)"
              fill="#575757"
            />
          </svg>
        </div>
        <div class="catalogue-btn-next" slot="button-next">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <path
              id="Combined_Shape_Copy_2"
              data-name="Combined Shape Copy 2"
              d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
              transform="translate(0 0)"
              fill="#575757"
            />
          </svg>
        </div>
      </div>
      <gallery-popup
        @close="close"
        :images="_.get(contentData, 'data.list[0].additional_images')"
        :imageId="selectedImage"
        :clickedIndex="clickedIndex"
      />
    </div>
  </div>
</template>

<script>
import GalleryPopup from "../Popups/GalleryPopup.vue";
import LightGallerySymbol from "@/components/LightGallerySymbol";
export default {
  props: ["contentData", "evenOdd"],
  components: { GalleryPopup, LightGallerySymbol },
  data() {
    return {
      swiperOptions: {
        spaceBetween: 30,
        watchOverflow: true,
        speed: 800,
        slidesPerView: 3,
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            scrollbar: {
              dragSize: 129
            }
          },
          414: {
            slidesPerView: 1.7,
            scrollbar: {
              dragSize: 129
            }
          },
          415: {
            slidesPerView: 1.8
          },
          515: {
            scrollbar: {
              dragSize: 176
            },
            slidesPerView: 2
          },
          767: {
            slidesPerView: 3
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
          dragSize: 300
        },
        navigation: {
          nextEl: ".catalogue-btn-next",
          prevEl: ".catalogue-btn-prev"
        }
        // Some Swiper option/callback...
      },

      selectedImage: false,
      clickedIndex: 0,
      pTopDesktop: 89,
      pBottomDesktop: 89
    };
  },
  computed: {
    swiper() {
      return this.$refs.gallery.$swiper;
    }
  },

  methods: {
    activeSwiper(index) {
      this.clickedIndex = index;
      this.selectedImage = true;
    },
    close() {
      this.selectedImage = false;
      this.clickedIndex = 0;
    }
  }
};
</script>

<style scoped>
/*gallery*/
.overlay-img {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
  overflow: hidden;
  z-index: 1;
  transition: 0.6s;
}
.img-filter.overlay-img {
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: 0.7s;
  z-index: 2;
}

.event-gallery .title {
  margin-bottom: 33px;
  line-height: 30px;
}
.gallery-list .image-cont {
  position: relative;
  width: 100%;
  height: 255px;
  overflow: hidden;
  border-radius: 12px;
  cursor: pointer;
}
.gallery-list .image-cont img {
  will-change: transform;
}
@media (min-width: 1025px) {
  .gallery-list .image-cont:hover img {
    transform: scale(1.1);
    filter: brightness(0.7);
  }
  .image-cont:hover .img-filter {
    opacity: 1;
  }
  .image-cont:hover .hover-symbol {
    opacity: 1;
    visibility: visible;
  }
}
.hover-symbol {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  right: 50%;
  top: 50%;
  z-index: 2;
  transform: translate(50%, -50%);
  transition: 0.6s;
}
.gallery-list img {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  border-radius: 12px;
  width: 100%;
  height: 100%;
  transition: 0.6s;
}
.gallery-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0px, 1fr));
  gap: 30px;
}
.gallerySwiper {
  width: 94vw;
}
@media (max-width: 1024px) {
  .gallery-list .image-cont:hover img {
    transform: unset;
  }
  .gallery-list .image-cont {
    height: 150px !important;
  }
  .gallery-list {
    grid-template-columns: repeat(3, minmax(0px, 1fr));
  }
}
@media (max-width: 767px) {
  .hover-symbol {
    opacity: 1;
    visibility: visible;
  }
  .img-filter.overlay-img {
    opacity: 1;
    visibility: visible;
  }
  .gallery-list {
    grid-template-columns: repeat(1, minmax(0px, 1fr));
  }
  /* .event-gallery {
    padding: 44px 0;
  } */
}
</style>
<style lang="scss">
.swiper-scrollbar-drag {
  background: var(--tbc-blue);
}
.swiper-scrollbar {
  background-color: #364756;
}
.nav-btns {
  justify-content: flex-end;
  margin-top: -15px;
  position: relative;
  width: fit-content;
  margin-left: auto;
  z-index: 9;
  .btn-prev {
    margin-right: 32px;
    svg {
      transform: rotate(180deg);
    }
  }
  .btn-prev,
  .btn-next {
    cursor: pointer;
    svg {
      transition: 0.6s;
      path {
        transition: 0.6s;
      }
    }
  }
}
@media (max-width: 767px) {
  .event-gallery .nav-btns.desk {
    bottom: 0px;
  }
}

.swiper-button-disabled svg path {
  // fill: #c6c6c6;
}
.swiper-button-disabled:hover svg path {
  fill: #c6c6c6;
}

@media (min-width: 1025px) {
  .btn-prev:hover svg path,
  .btn-next:hover svg path {
    fill: #00aeef;
  }
}
.event-gallery .swiper-wrapper {
  padding-bottom: 89px;
}
.event-gallery .swiper-container-horizontal > .swiper-scrollbar {
  width: 70% !important;
  z-index: 99;
}

@media (max-width: 1023px) {
  .event-gallery .swiper-container-horizontal > .swiper-scrollbar {
    width: 70% !important;
  }
  .event-gallery .swiper-wrapper {
    padding-bottom: 65px;
  }
}
@media (max-width: 413px) {
  .event-gallery .swiper-container-horizontal > .swiper-scrollbar {
    width: 60% !important;
  }
}
</style>
